import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-daterange', 'TIME_START', 'Laiko pradžia');
Labels.set('ui-daterange', 'TIME_END', 'Laiko pabaiga');
